export const contacatInfo = {
  phoneNumber: '90001234',
  emailAddress: 'Info@agah.com',
  version: '1.1.1',
  officeAddress: 'تهران، خیابان نلسون ماندلا (آفریقا)، بالاتر از میرداماد، بن بست پیروز، پلاک 13',
  mapUrl: 'https://www.google.com/maps/place/35.76601805210218,  51.421012223166166',
};
export const socialLinks = {
  telegramChannel: 'https://t.me/+yfcznuWpTXQ0Mzlk',
  instagram: 'https://www.instagram.com/agahcom',
  telegram: 'https://t.me/+yfcznuWpTXQ0Mzlk',
  linkedin: 'https://www.linkedin.com/company/agahgroup/',
  aparat: 'https://www.aparat.com/agahex',
};

export const GetBankLogoBaseUrl = () => {
  return `/resources/logo/bank`;
};

export const GetFundsLogBaseUrl = () => {
  return `/resources/logo/fund`;
};
